 import emptyfile from "../assets/emptyfile.webp";
export const No_transactions = ({
  message = "There are"
}) => (
  <div className="center items-back p-22 ">
    <div className="text-h2 bold blue">{message}</div> 
    <div className="text-h3 text-off no-tx-text-loop ">
      {message} no transactions recorded for the.
    </div>
    <img className="icon_photo center" src={emptyfile}></img>  
  </div>
);
